import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/redesign-temp/girl-s3-p2.jpg")